var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HubHero'),_c('VerticalSelector'),_c('PlatformSection'),_c('HubHowItWorks'),_c('ContactForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }